module.exports = __webpack_public_path__ + "img/thief-in-the-night.690bd7aa.jpg";